function excludeLocationSearchStrings(currentSearchStr: string, searchStrToExclude: string) {
    const currentSearchParams = new URLSearchParams(currentSearchStr);
    const searchParamsToExclude = new URLSearchParams(searchStrToExclude);
    searchParamsToExclude.forEach((value, key) => {
        currentSearchParams.delete(key);
    });
    return currentSearchParams.toString();
}

export default excludeLocationSearchStrings;
